import { Link } from '@nobia/zeus-components/lib/router'
import styled, { css } from '@nobia/zeus-components/lib/styled'
import PropTypes from 'prop-types'
import React from 'react'

import { OutlineButtonCss, SolidButtonCss } from '../button/Button'

const ResetCss = css`
  text-decoration: none;
  display: block;
`

export const LinkOutlineButton = styled(
  ({ buttonType, size, fullWidth, children, ...rest }) => (
    <Link {...rest}>{children}</Link>
  )
)`
  ${OutlineButtonCss}
  ${ResetCss}
`

LinkOutlineButton.defaultProps = {
  buttonType: 'primary',
  size: 'default',
}

LinkOutlineButton.propTypes = {
  buttonType: PropTypes.oneOf(['primary', 'secondary']),
  size: PropTypes.oneOf(['small', 'default', 'large']),
  children: PropTypes.node.isRequired,
}
export const LinkSolidButton = styled(
  ({ buttonType, size, fullWidth, disabled, children, ...rest }) => (
    <Link {...rest} onClick={disabled ? (e) => e.preventDefault() : undefined}>
      {children}
    </Link>
  )
)`
  ${SolidButtonCss}
  ${ResetCss}
   ${({ disabled }) =>
    disabled &&
    css`
      pointer-events: none;
      color: ${(p) => p.theme.buttons.disabled.color};
      background-color: ${(p) => p.theme.buttons.disabled.background};
      cursor: not-allowed;
    `}
`

LinkSolidButton.defaultProps = {
  buttonType: 'primary',
  size: 'default',
  fullWidth: false,
  disabled: false,
}

LinkSolidButton.propTypes = {
  buttonType: PropTypes.oneOf(['primary', 'secondary']),
  size: PropTypes.oneOf(['small', 'default', 'large']),
  children: PropTypes.node.isRequired,
  fullWidth: PropTypes.bool,
  disabled: PropTypes.bool,
}
